/* tslint:disable */

export enum UserRole {
  TreetopAdmin = 0,
  TreetopAnalytics = 1,
  TreetopMedicalExpert = 2,
  TreetopSeniorMedicalExpert = 3,
  ContentPartnerOrganisationAdmin = 4,
  ContentPartnerMedicalExpert = 5,
  ContentPartnerSeniorMedicalExpert = 6,
  ClinicalPartnersOrganisationAdmin = 7,
  ClinicalPartnersClinician = 8,
  ClinicalPartnersSeniorClinician = 9,
  ClinicalPartnersEditorClinician = 10,
  ServiceUser = 11,
  Reviewer = 12,
  TemporaryEditor = 13,
}
